'use strict';

angular.module('userRequestEditControllers')

    .controller('MissingHighPrivilegesController', ['$state', '$scope', 'editAccessRequestService', function ($state,$scope, editAccessRequestService) {

        $scope.expirationMaxDate = moment().add(1, 'years').calendar();

        $scope.addAuthorizationHighPrivilege = function (highPrivilegeSysRole, isValid) {
            if (isValid) {
                var requestId = this.userRequest.UserAccessRequestID;
                var systemRoleId = highPrivilegeSysRole.SystemRoleID;

                var now = moment();
                var expirationDateObj = moment(this.exceptionExpirationDate);

                var completeJustification = 'The employee needs an admin Account for"' +
                    '"' + this.highPrivilegeSysRole.SystemRoleName + '" in ' + this.highPrivilegeSysRole.SystemName + '.' +
                    '\n' +
                    now.format('YYYY-MM-DD') +
                    ' - Exception by ' + this.authenticatedUser.IdentityName +
                    ' valid until ' + expirationDateObj.format('MMMM DD, YYYY') + ': ' +
                    '\n' +
                    this.exceptionJustification;

                editAccessRequestService.systemRolePendings.addAuthorizationExceptionForSupervisor(requestId, systemRoleId,
                    completeJustification,
                    this.exceptionExpirationDate)
                    .then(function () {
                        $state.reload();
                    });
            }
        }
    }]);